module.exports = __webpack_public_path__ + "media/images/knockout__winnerDeco@3x-53e7b6223614139d814f0a3688408df4.png";